class ISUE_ElectricConnectionRegulationHoursEdit extends Tango.Component {
	widgetDidMount() {
		var t = this;
		document.querySelectorAll(".ecregulationhoursedit input").forEach(cb => {
			cb.addEventListener("change", function (e) {
				var checkBox = e.target;
				t.colorCell(checkBox.parentElement.getAttribute("data-hour"));
			});
			t.colorCell(cb.parentElement.getAttribute("data-hour"));
		});
	}

	colorCell(index) {
		var highlowCheckbox = document.querySelector("tr.ecregulationhoursedit-highlow td[data-hour='" + index + "'] input");
		var customerCheckbox = document.querySelector("tr.ecregulationhoursedit-customer td[data-hour='" + index + "'] input");
		var cell = document.querySelector("tr.ecregulationhoursedit-color td[data-hour='" + index + "']");
		cell.classList.value = "";
		if (highlowCheckbox.checked) {
			if (customerCheckbox.checked)
				cell.classList.add("ecregulationhoursedit-highcustomer");
			else
				cell.classList.add("ecregulationhoursedit-high");
		}
		else {
			if (customerCheckbox.checked)
				cell.classList.add("ecregulationhoursedit-lowcustomer");
			else
				cell.classList.add("ecregulationhoursedit-low");
		}
	}
};

Tango.registerComponent(ISUE_ElectricConnectionRegulationHoursEdit, sp => ({
	cu: sp.commonUtils,
	au: sp.ajaxUtils
}));